import { useState } from 'react';
import { Trans } from '../i18n/Trans';
import { ApiHelper } from '../helper/ApiHelper';
import type { PublicUser } from './LoginPage';

interface RegResp {
  token: string;
  user: PublicUser;
}

/** 注册：只要邮箱 + 密码。注册成功直接给会话，不用再登一次。 */
export function RegisterPage({
  onDone, onGoLogin, onCancel, embedded = false,
}: { onDone: (u: PublicUser) => void; onGoLogin: () => void; onCancel: () => void; embedded?: boolean }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr('');
    setBusy(true);
    try {
      const r = await ApiHelper.call<RegResp>('/api/auth/register', 'POST',
        { email: email.trim(), password });
      ApiHelper.setToken(r.token);
      onDone(r.user);
    } catch (e) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={embedded ? 'login-embed' : 'login-page'}>
      <div className="login-card">
        <div className="login-title">{Trans.t('register.title')}</div>
        <p className="login-sub">{Trans.t('app.slogan')}</p>

        <label className="login-label" htmlFor="rg-email">{Trans.t('login.email')}</label>
        <input
          id="rg-email" type="email" autoComplete="email" value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
        />

        <label className="login-label" htmlFor="rg-pw">{Trans.t('login.password')}</label>
        <input
          id="rg-pw" type="password" autoComplete="new-password" value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
        />
        <div className="login-rule">{Trans.t('register.pwRule')}</div>

        {err && <div className="error-box">{err}</div>}

        <button className="login-btn" disabled={busy || !email || !password} onClick={submit}>
          {busy ? Trans.t('common.loading') : Trans.t('register.submit')}
        </button>

        <div className="login-foot">
          <button className="linkbtn" onClick={onGoLogin}>{Trans.t('register.haveAccount')}</button>
          {!embedded && (
            <button className="linkbtn" onClick={onCancel}>{Trans.t('common.back')}</button>
          )}
        </div>
      </div>
    </div>
  );
}
